import { PercentageOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar, Button, Col, Modal, Row, Typography } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";
import { useState } from "react";
import SendRequest from "./SendRequest";

const MLSInfoes = () => {
  const { Text } = Typography;
  const[isShowSendRequest,setIsShowSendRequest] = useState(false)
  return (
    <>
      <Col xs={24}>
        <Row gutter={[0, 10]}>
          <Col span={24} className="!flex justify-center">
            <Text className="">
              <span className="!text-2xl !font-bold">MLS Bilgileri</span>
            </Text>
          </Col>
          <Col xs={24}>
            <div className="!flex gap-2">
              <div>
                <Avatar className="!w-[50px] !h-[50px]">MK</Avatar>
              </div>
              <div className="!flex gap-2 items-center !w-full">
                <div>
                  <div>
                    <Text className="!text-xl !text-[#164194]">
                      Mehment Koc
                    </Text>
                  </div>
                  <div>
                    <Text className="!text-xs !text-[#6E7583]">
                      Bireysel Satıcı
                    </Text>
                  </div>
                </div>

                <div>
                  <Button className="!bg-[#dbe8ff]  ">
                    <div className="!flex items-center gap-1">
                      <UserOutlined className="!text-blue-500 !text-sm " />
                      <Text className=" !text-blue-500 !text-sm ">
                        İletişim Bilgileri
                      </Text>
                    </div>
                  </Button>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={24} className="!flex gap-2 ">
            <Text className="!text-2xl !text-black">Komisyon</Text>
            <div className="!flex gap-1 items-center">
              <Avatar className="!bg-[#DCE8FF] !w-[40px] !h-[40px]">
                <PercentageOutlined className="!text-[#164194] !text-2xl" />
                <Text  className="!text-[#164194] !text-2xl">10</Text>
              </Avatar>
             
            </div>
          </Col>
          <Col span={24} className="!flex ">
            <Text className="!text-sm !text-[#6A6A6A]">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam id
              arcu id leo tempus convallis. Donec sit amet sagittis sem.Lorem
              ipsum is typically a corrupted version of De finibus bonorum et
              malorum, a 1st-century BC text by the Roman statesman and
              philosopher Cicero, with words altered, added, and removed to make
              it nonsensical and improper Latin. The first two words themselves
              are a truncation of dolorem ipsum ("pain itself"). Versions of the
              Lorem ipsum text have been used in typesetting at least since the
              1960s, when it was popularized by advertisements for Letraset
              transfer sheets.[1] Lorem ipsum was introduced to the digital
              world in the mid-1980s, when Aldus employed it in graphic and
              word-processing templates for its desktop publishing program
              PageMaker. Other popular word processors, including Pages and
              Microsoft Word, have since adopted Lorem ipsum,[2] as have many
              LaTeX packages,[3][4][5] web content managers such as Joomla! and
              WordPress, and CSS libraries such as Lorem ipsum dolor sit amet,
              consectetur adipiscing elit. Etiam id arcu id leo tempus
              convallis. Donec sit amet sagittis sem.Lorem ipsum is typically a
              corrupted version of De finibus bonorum et malorum, a 1st-century
              BC text by the Roman statesman and philosopher Cicero, with words
              altered, added, and removed to make it nonsensical and improper
              Latin. The first two words themselves are a truncation of dolorem
              ipsum ("pain itself"). Versions of the Lorem ipsum text have been
              used in typesetting at least since the 1960s, when it was
              popularized by advertisements for Letraset transfer sheets.[1]
              Lorem ipsum was introduced to the digital world in the mid-1980s,
              when Aldus employed it in graphic and word-processing templates
              for its desktop publishing program PageMaker. Other popular word
              processors, including Pages and Microsoft Word, have since adopted
              Lorem ipsum,[2] as have many LaTeX packages,[3][4][5] web content
              managers such as Joomla! and WordPress, and CSS libraries such as
            </Text>
          </Col>
          <Col xs={24}>
          <Button onClick={()=>{setIsShowSendRequest(true)}} size="large" className="!text-base !bg-[#ffc600] !px-6 !text-black">
           MLS Portföyüme Ekle
          </Button>
        </Col>
        </Row>
      </Col>
      <Modal open={isShowSendRequest} onCancel={()=>{
        setIsShowSendRequest(false)
      }} 
      footer={false}
      >
<SendRequest/>
      </Modal>
    </>
  );
};

export default MLSInfoes;
